import React from 'react';
import styles from './ReadingTarger.module.scss';

import iconTeacher from '../../ClassNew/images/icon_teacher.png';
import iconParent from '../../ClassNew/images/icon_home_black.png';
import iconBoomer from '../../../images/boomer-icon.png';

import moment from 'moment';

function ReadingLogTracker(props) {
    return (
        <div className={styles.progressWrapper}>
            <svg className={styles.progressRing} width='50' height='50'>
                <circle
                    className={styles.ringBg}
                    cx='25'
                    cy='25'
                    r='22'
                    stroke='#eee'
                    strokeWidth='4'
                    fill='none'
                />
                {props.hasTarget && (
                    <circle
                        className={`
                            ${
                                props.percentage === 0
                                    ? styles.ringNoProgress
                                    : props.percentage < 100
                                    ? styles.ringProgress
                                    : styles.ringFull
                            }
                        `}
                        cx='25'
                        cy='25'
                        r='22'
                        stroke='#4caf50'
                        strokeWidth='4'
                        fill='none'
                        strokeDasharray={2 * Math.PI * 22}
                        strokeDashoffset={
                            2 *
                            Math.PI *
                            22 *
                            (1 -
                                (props.percentage === 0
                                    ? 100
                                    : props.percentage) /
                                    100)
                        }
                        strokeLinecap='round'
                        transform='rotate(-90 25 25)'
                    />
                )}
            </svg>
            {props.hasTarget ? (
                !props.viewReadingTargets ? (
                    <img
                        src={props.icon}
                        width={24}
                        alt={props.iconAlt}
                        className={styles.progressImage}
                    />
                ) : (
                    <div
                        className={`${styles.progressImage} ${styles.viewReadingTargetsContainer}`}
                    >
                        <img src={props.icon} width={12} alt={props.iconAlt} />
                        <div className={styles.readingTargetsOverview}>
                            {' '}
                            {props.count ? props.count : 0}/
                            {props.target ? props.target : 0}
                        </div>
                    </div>
                )
            ) : (
                <img
                    src={props.icon}
                    width={24}
                    alt={props.iconAlt}
                    className={styles.progressImage}
                />
            )}
        </div>
    );
}

export default function ReadingTarget({
    student,
    viewReadingTargets,
    weekStart,
    currentWeekSelected,
}) {
    let teacherTarget;
    let teacherCount;
    let parentTarget;
    let parentCount;
    let studentTarget;
    let studentCount;
    let teacherReportPercentage;
    let parentReportPercentage;
    let studentReportPercentage;

    const showNoTarget = () => {
        return (
            <>
                <ReadingLogTracker
                    hasTarget={false}
                    percentage={0}
                    target={0}
                    count={0}
                    icon={iconTeacher}
                    viewReadingTargets={viewReadingTargets}
                    iconAlt='Teacher reads'
                ></ReadingLogTracker>
                <ReadingLogTracker
                    hasTarget={false}
                    percentage={0}
                    icon={iconParent}
                    target={0}
                    count={0}
                    viewReadingTargets={viewReadingTargets}
                    iconAlt='Parent reads'
                ></ReadingLogTracker>
                <ReadingLogTracker
                    hasTarget={false}
                    percentage={0}
                    viewReadingTargets={viewReadingTargets}
                    target={0}
                    count={0}
                    icon={iconBoomer}
                    iconAlt='Boomer reads'
                ></ReadingLogTracker>
            </>
        );
    };

    const resolveLogingTargetsFromWeeklyTarget = () => {
        teacherTarget = student.studentWeeklyTarget
            ? student.studentWeeklyTarget.teacherLogsTarget
            : 0;
        parentTarget = student.studentWeeklyTarget
            ? student.studentWeeklyTarget.parentLogsTarget
            : 0;
        studentTarget = student.studentWeeklyTarget
            ? student.studentWeeklyTarget.studentLogsTarget
            : 0;
    };

    const resolveLogingPercentages = (
        teacherLogsCount,
        parentLogsCount,
        studentLogsCount
    ) => {
        teacherReportPercentage =
            teacherLogsCount && teacherTarget
                ? teacherTarget < teacherLogsCount
                    ? 100 // target changed to an amount smaller than the counts
                    : (teacherLogsCount / teacherTarget) * 100 // percentage
                : 0;
        parentReportPercentage =
            parentLogsCount && parentTarget
                ? parentTarget < parentLogsCount
                    ? 100 // target changed to an amount smaller than the counts
                    : (parentLogsCount / parentTarget) * 100 // percentage
                : 0;
        studentReportPercentage =
            studentLogsCount && studentTarget
                ? studentTarget < studentLogsCount
                    ? 100 // target changed to an amount smaller than the counts
                    : (studentLogsCount / studentTarget) * 100 // percentage
                : 0;
    };

    const resolveWeeklyStudentReportDataOfDate = () => {
        return student.weeklyStudentReportData.find(
            (weeklyReportData) =>
                weeklyReportData.weekStart ===
                moment(weekStart).format('YYYY-MM-DD')
        );
    };

    const anyTargetOnStudent = () => {
        return (
            student.studentWeeklyTarget &&
            (student.studentWeeklyTarget.parentLogsTarget ||
                student.studentWeeklyTarget.studentLogsTarget ||
                student.studentWeeklyTarget.teacherLogsTarget)
        );
    };

    const anyLogReportsOnStudent = () => {
        return (
            student.weeklyStudentReportData &&
            student.weeklyStudentReportData.length
        );
    };

    const setLogProgressToZero = () => {
        teacherReportPercentage = 0;
        parentReportPercentage = 0;
        studentReportPercentage = 0;
    };

    // Handles the case where there are no weekly tarhgets
    if (!student.studentWeeklyTarget) {
        showNoTarget();
    }

    if (currentWeekSelected) {
        // Take targets from studentWeeklyTarget and search progress into weeklyStudentReportData
        if (anyTargetOnStudent()) {
            resolveLogingTargetsFromWeeklyTarget();

            if (anyLogReportsOnStudent()) {
                // Has targets and progress
                const weeklyStudentReportData =
                    resolveWeeklyStudentReportDataOfDate();
                const { parentLogsCount, studentLogsCount, teacherLogsCount } =
                    weeklyStudentReportData;

                teacherCount = teacherLogsCount;
                parentCount = parentLogsCount;
                studentCount = studentLogsCount;

                resolveLogingPercentages(teacherCount, parentCount, studentCount);
            } else {
                // Has targets but no progress
                setLogProgressToZero();
            }
        } else {
            showNoTarget();
        }
    } else {
        // Take targets and progress from weeklyStudentReportData only.
        if (anyLogReportsOnStudent()) {
            const weeklyStudentReportData =
                resolveWeeklyStudentReportDataOfDate();
            
            if (weeklyStudentReportData) {
                // Has some targets and maybe progress
                const { parentLogsCount, studentLogsCount, teacherLogsCount } =
                    weeklyStudentReportData;

                teacherTarget = weeklyStudentReportData.teacherLogsTarget;
                teacherCount = teacherLogsCount;

                parentTarget = weeklyStudentReportData.parentLogsTarget;
                parentCount = parentLogsCount;

                studentTarget = weeklyStudentReportData.studentLogsTarget;
                studentCount = studentLogsCount;

                resolveLogingPercentages(teacherCount, parentCount, studentCount);
            } else {
                // Has no targets and no progress on the specified date.
                showNoTarget();
            }
        } else {
            showNoTarget();
        }
    }

    return (
        <>
            <ReadingLogTracker
                hasTarget={teacherTarget}
                percentage={teacherReportPercentage}
                target={teacherTarget}
                count={teacherCount}
                icon={iconTeacher}
                viewReadingTargets={viewReadingTargets}
                iconAlt='Teacher reads'
            ></ReadingLogTracker>
            <ReadingLogTracker
                hasTarget={parentTarget}
                percentage={parentReportPercentage}
                icon={iconParent}
                target={parentTarget}
                count={parentCount}
                viewReadingTargets={viewReadingTargets}
                iconAlt='Parent reads'
            ></ReadingLogTracker>
            <ReadingLogTracker
                hasTarget={studentTarget}
                percentage={studentReportPercentage}
                viewReadingTargets={viewReadingTargets}
                target={studentTarget}
                count={studentCount}
                icon={iconBoomer}
                iconAlt='Boomer reads'
            ></ReadingLogTracker>
        </>
    );
}
